import React, { useEffect, useState } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import List from '@mui/joy/List';
import ListItem from '@mui/material/ListItem';
import Radio from '@mui/joy/Radio';
import RadioGroup from '@mui/joy/RadioGroup';
import { Checkbox,  CircularProgress,  DialogContent, FormControl, FormControlLabel, FormHelperText, ListItemIcon, ListSubheader } from '@mui/material';

function CustomPopOver(props) {

    let { onClose, selectedValue, open, title, descriptionContent, primaryButton, primaryButtonColor, listData, listTitle, listSelectAll, listControl, listHeight, showLowerDescription, initialLoading } = props;
  
    const [checked, setChecked] = useState([]);
    const [loading, setLoading] = useState(initialLoading ?? true);

    useEffect(()=>{
    	setChecked([])
    },[loading])

    useEffect(() => {
		if (open) {
			setTimeout(() => {
				setLoading(false)
			}, 2000)
		} else {
			setLoading(true)
		}
  	}, [open]);
   
	const handleToggle = (value) => () => {
		const currentIndex = checked.indexOf(value);
		let newChecked = [...checked];

		if(value.label === 'Select All') {
		if(checked.length === listData.length){
			newChecked = []
		} else {
			newChecked = [...listData]
		}
		}
		else{
		if (currentIndex === -1) {
			newChecked.push(value);
		} else {
			newChecked.splice(currentIndex, 1);
		}
		}
		
		setChecked(newChecked);
	};

	const handleRadioChange = (event) => {
		setChecked([event.target.value]);
	};

    const handleClose = () => {
      onClose(null);
    };

    const primaryButtonEvent = () => {
      onClose(checked);
    };
  
    return (
      <>
      {
        
        <Dialog className='dialog-cont' sx={{
          borderRadius: '20px',
          '& .MuiDialog-paper': {
            borderRadius: '16px',
            minWidth: '40vw',
            maxWidth: '50vw',
            maxHeight: '60vh'
          },
          margin: '0 auto'
        }} slotProps={{ dialog: { backgroundColor: 'red' }}} onClose={handleClose} open={open}>

{loading && open ? ( <>
    <DialogTitle>Loading</DialogTitle>
    
    <div className='dialog-cont--loading'><CircularProgress /></div>
   
    </>) : <>
          <DialogTitle>{title}</DialogTitle>

          <DialogContent className='dialog-cont--content'>{descriptionContent}

          {listData && listControl === 'CheckBox' ? <List className='list' sx={{ pt: 0 }} 
                            aria-labelledby='nested-list-subheader'
                            subheader={
                              <ListSubheader className='list__subheader' component='h4' 
                              sx={{ color: '#00563C', textDecoration: 'underline', fontWeight: 400, fontSize: '18px', paddingLeft: '20px'}} 
                              id='nested-list-subheader'>{listTitle}</ListSubheader>
                            }>
                    {listSelectAll ? <ListItem className='list__item' sx={{ width: 'auto', paddingTop: '0px', paddingBottom: '0px'}} disableGutters key='selectall'>
                        <ListItemButton className='list__item__button' role={undefined} onClick={handleToggle({label:'Select All',value: false})} dense>
                          <ListItemIcon>
                            <Checkbox
                              edge='start'
                              checked={checked.length === listData.length ? true : false}
                              indeterminate={checked.length > 0 && checked.length < listData.length}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ 'aria-labelledby': 'Select All' }}
                            />
                          </ListItemIcon>
                          <div className='list__item__button'>
                          <ListItemText className='list__item__button__label' sx={{fontSize: 20, fontWeight: 'bolder'}} id='selectall' primary='Select All' />
                          </div>
                          
                        </ListItemButton>
                      </ListItem> : null}
            {listData.map((item, index) => {
              const labelId = `Location item ${item.label}`;

              return (<ListItem className='list__item' sx={{ width: 'auto', paddingTop: '0px', paddingBottom: '0px'}} disableGutters key={index}>
                        <ListItemButton className='list__item__button' role={undefined} onClick={handleToggle(item)} dense>
                          <ListItemIcon>
                            <Checkbox
                              edge='start'
                              checked={checked.indexOf(item) !== -1}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ 'aria-labelledby': labelId }}
                            />
                          </ListItemIcon>
                          <div className='list__item__button'>
                          <ListItemText className='list__item__button__label' sx={{fontSize: 20, fontWeight: 'bolder'}} id={labelId} primary={item.label} />
                          <ListItemText className='list__item__button__subLabel' sx={{fontSize: 16, color: '#aeaeae', fontWeight: 'normal'}} primary={item.subLabel}/>
                          </div>
                          
                        </ListItemButton>
                      </ListItem>
                    );
              })
            }
          </List> : null}

          {listData && listControl === 'Radio' ? <>
                <h5 className='list__subheader' component='h4' 
                              sx={{ color: '#00563C', textDecoration: 'underline', fontWeight: 400, fontSize: '18px'}} 
                              id='nested-list-subheader'>{listTitle}</h5>
                <RadioGroup defaultValue=''  className='list__radioControl' aria-label='Locations' name='customized-radios' onChange={handleRadioChange}>
                <List className='list'
                    sx={{
                    minWidth: 240,
                    maxHeight: `${listHeight}`,
                    '--List-gap': '0.5rem',
                    '--ListItem-paddingY': '1rem',
                    // '--ListItem-margin': '1rem',
                    '--ListItemDecorator-size': '32px',
                    'overflow': 'hidden'
                    }}
                >
                {listData.map((item, index) => {
                  const labelId = `Location item ${item.label}`;
                  return (
                    //   <FormControlLabel className='radio-control' key={index} aria-label={labelId} value={item.label} control={<Radio/>}
                    //   label={item.label} disabled={item.disabled}/>
                    //   );
                    // <ListItem variant='outlined' key={index} sx={{ boxShadow: 'sm' }} htmlFor={`label${index}`}>
          
                        <FormControl key={index}>
                            <Radio className='list__radio' aria-label={labelId} value={item.label} id={`label${index}`} label={item.label} disabled={item.disabled}/>
                            <FormHelperText className='list__subLabel'>
                            {item.subLabel}
                            </FormHelperText>
                        </FormControl>

                    // </ListItem>
                  )})
                }
                </List>
                </RadioGroup>

                </>: null}


          {showLowerDescription}
                </DialogContent>
          <div className='pop-over--container--alignright pop-over--container__buttongroup'>
          <button className='pop-over--container--alignright__button pop-over--container--alignright--secondaryButton' onClick={()=>handleClose(selectedValue)}>Cancel</button>
          {primaryButton ? <button data-testid='primaryButton' className='pop-over--container--alignright__button pop-over--container--alignright--primaryButton' style={{backgroundColor : primaryButtonColor || '#00563C'}} disabled={listData?.length > 0 && checked.length === 0} onClick={()=>primaryButtonEvent()}>{primaryButton}</button>: null}
          </div>
          </>}

        </Dialog>
      }
      </>
      
    );
  }

	CustomPopOver.defaultProps = {
		initialLoading: true,
	};

export default CustomPopOver;
